import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EmailOutlined } from "@material-ui/icons";
import clsx from "clsx";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useAsyncFn } from "react-use";
import logo from "../images/mobile-phone.png";

const useStyles = makeStyles((theme) => ({
  insidePaper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  main: {
    marginTop: theme.spacing(7),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#5046B2",
    height: 50,
  },
  paper: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      // padding: theme.spacing(4),
    },
  },
  iconContainer: {
    display: "flex",
    width: 63,
    height: 63,
    background: "#E5DBFF",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
  },
  iconContainerOuter: {
    display: "flex",
    width: 96,
    height: 96,
    background: "#F3F0FF",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 38,
  },
}));

export default function ForgotPassword() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const { t } = useTranslation();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");

  const [state, postForgotPassword] = useAsyncFn(async () => {
    const response = await axios.post("/auth/send-otp", {
      email,
      action: "FORGOT_PASSWORD",
    });
    return response.data;
  }, [email]);

  useEffect(() => {
    if (state?.error) {
      if (state?.error?.response?.data?.error) {
        setErrorMessage(state?.error?.response?.data?.error);
        return;
      }
      setErrorMessage(t("Internal error"));
    }
  }, [state, setErrorMessage, t]);

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={clsx(classes.main, "form-style")}
      >
        <CssBaseline />
        <Box
          maxWidth="xs"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginBottom="50px"
        >
          <img src={logo} alt="flyins" width="100" height="100" />
          <Grid item xs={12}>
            <Typography
              color="primary"
              style={{
                fontSize: "4rem",
                paddingLeft: "25px",
                fontFamily: "Carter One, cursive",
              }}
            >
              Flyins
            </Typography>
          </Grid>
        </Box>

        <div className={classes.paper}>
          <Paper elevation={2} style={{ width: "100%" }}>
            <div className={classes.insidePaper}>
              <form
                className={classes.form}
                onSubmit={(e) => {
                  e.preventDefault();
                  postForgotPassword();
                }}
              >
                {state?.value?.success ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "50px",
                      textAlign: "center",
                    }}
                  >
                    <div className={classes.iconContainerOuter}>
                      <div className={classes.iconContainer}>
                        <EmailOutlined
                          style={{
                            color: "#6741D9",
                            fontSize: "39",
                            textAlign: "center",
                          }}
                        />
                      </div>
                    </div>
                    <Typography
                      component="h1"
                      variant="h4"
                      style={{ marginBottom: 38 }}
                    >
                      {t("check your email")}
                    </Typography>
                    <Typography style={{ color: "#495057" }}>
                      {t("email sent", { email })}
                    </Typography>
                    <Button
                      onClick={() => {
                        history.push(`/verify/resetpassword/${email}`);
                      }}
                      style={{ fontWeight: "bold", marginTop: 38 }}
                      type="button"
                      fullWidth
                      variant="contained"
                      color="primary"
                      id="submit"
                      className={classes.submit}
                    >
                      {t("Continue")}
                    </Button>
                  </div>
                ) : (
                  <>
                    <Typography
                      component="h1"
                      variant="h4"
                      style={{ marginBottom: 10, fontWeight: 500 }}
                    >
                      {t("Forgot Password")}
                    </Typography>
                    <Typography
                      component="p"
                      variant="caption"
                      style={{ marginTop: 10, fontSize: 14, color: "#495057" }}
                    >
                      {t("Forgot password description")}
                    </Typography>
                    {errorMessage && (
                      <Typography
                        style={{
                          color: "red",
                          marginBottom: 5,
                          textAlign: "center",
                        }}
                      >
                        {errorMessage}
                      </Typography>
                    )}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label={t("Email Address")}
                      name="email"
                      autoComplete="email"
                      value={email}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailOutlined />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button
                      disabled={state.loading}
                      style={{ fontWeight: "bold" }}
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      id="submit"
                      className={classes.submit}
                    >
                      {state.loading
                        ? "Resetting Password"
                        : t("Reset Password")}
                    </Button>
                  </>
                )}
              </form>
            </div>
          </Paper>
        </div>
      </Container>
    </>
  );
}
